import React, { useEffect, useRef } from "react";
import adobeAnalytics from "../assets/images/aa.png";
import launch from "../assets/images/launch.png";
import aep from "../assets/images/aep.png";
import ot from "../assets/images/onet.png";
import qm from "../assets/images/qm.png";
import qualtrics from "../assets/images/qual.png";
import dynatrace from "../assets/images/dynatrace.png";
import ga4 from "../assets/images/ga4.png";
import gtm from "../assets/images/gtm.svg";
import audience from "../assets/images/audience.png";
import target from "../assets/images/target.png";
import databricks from "../assets/images/databricks.png";


import javasscript from "../assets/images/js.webp";
import react from "../assets/images/react.png";
import angular from "../assets/images/angular.png";
import htmll from "../assets/images/html.jpg";
import csss from "../assets/images/css.png";
import typescriptt from "../assets/images/typescript.svg";

import nodejs from "../assets/images/nodejs.jpeg";
import python from "../assets/images/python.png";
import MongoDB from "../assets/images/mongodb.svg";
import postgresql from "../assets/images/postgresql.png";

import WinnerAward from "../assets/images/winner-award.png";
import WinnerAward2 from "../assets/images/winner-award2.png";
import WinnerAward3 from "../assets/images/winner-award3.png";
import WinnerAward4 from "../assets/images/winner-award4.png";

const Resume = () => {
  const colors = [
    "#BCE70C",
    "#33f45c",
    "#00CC97",
    "#FFDB59",
    "#6F39FD",
    "#FF7D61",
  ];
  const progressRef = useRef(null);
  const hasAnimated = useRef(false); // Track if the animation has already run

  useEffect(() => {
    const progressSection = progressRef.current;
    if (!progressSection) return; // Ensure the ref is valid
    const items = progressSection.querySelectorAll(".progress-item");
    const observerOptions = { threshold: 0.1 };

    function handleIntersection(entries, observer) {
      if (entries[0].isIntersecting && !hasAnimated.current) {
        items.forEach((item, index) => {
          let num = parseInt(item.dataset.num);
          let count = 0;
          let color = colors[index % colors.length];
          let interval = setInterval(() => {
            if (count === num) {
              clearInterval(interval);
            } else {
              count++;
              item.style.background = `conic-gradient(${color} ${count}%, #80808047 0deg)`;
              item.setAttribute("data-value", `${count}%`);
              item.innerHTML = `${count}%`;
            }
          }, 15);
        });
        observer.unobserve(progressSection);
        hasAnimated.current = true; // Mark that the animation has run
      }
    }

    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions
    );
    observer.observe(progressSection);

    return () => observer.disconnect();
  }, [colors]);

  return (
    <>
      {/* <!-- ====================================== Section Education Experience ===================================== --> */}
      <section className="education-experience" id="work">
        <div className="row">
          <div className="col-xxl-12 col-lg-12">
            <div className="heading-container">
              <h2 className="section-heading-text about-me fade_up">
                Work Experience.
              </h2>
              <div className="line"></div>
            </div>
            <div className="education position-relative">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">SENIOR ANALYTICS & TARGET DEVELOPER</p>
                <p className="cursus university">ROGERS / 11/2021 - <span className="text-white">Current</span></p>
                <p className="cursus">
                  Specialized in analytics solution development using Adobe Launch, Adobe Analytics, OneTrust, and GA4 to optimize user experiences and drive data-informed decisions. Led end-to-end tag implementation, consent management, and event tracking to ensure privacy-compliant, accurate data collection and reporting across platforms.
                </p>
              </div>
            </div>
            <div className="education position-relative">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">SENIOR SOFTWARE DEVELOPER</p>
                <p className="cursus university">CIBC / 03/2021 - 11/2021</p>
                <p className="cursus">
                  Played a key role in migrating internal applications to Angular, collaborating with cross-functional teams to ensure a smooth transition. Enhanced performance and user-friendliness, delivering solutions that aligned with the strategic objectives of CIBC and Simplii.
                </p>
              </div>
            </div>
            <div className="education position-relative">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">SOFTWARE DEVELOPER</p>
                <p className="cursus university">Telus Mobile / 01/2020 - 03/2021</p>
                <p className="cursus">
                  Engineered responsive user interfaces for TELUS using React, Redux, and the Telus Design System, while developing backend services with Node.js and MongoDB to ensure seamless integration and scalability. Focused on building full-stack solutions that delivered high performance and optimized user experience.
                </p>
              </div>
            </div>
            <div className="education position-relative">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">SOFTWARE DEVELOPER</p>
                <p className="cursus university">Freedom Mobile / 01/2019 - 01/2020</p>
                <p className="cursus">
                  Built dynamic front-end portals for Freedom Mobile using ReactJS, Redux, and Contentful, while creating a scalable Web Component Library and implementing theming for flexible designs. Also collaborated with analytics teams to integrate event tracking and Google Tag Manager for precise user interaction insights.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xxl-12 col-lg-12 mt-4">
            <div className="heading-container">
              <h2 className="section-heading-text about-me fade_up">
                Education.
              </h2>
              <div className="line"></div>
            </div>
            <div className="education position-relative">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Computer Programmer</p>
                <p className="cursus university">
                  Seneca College / 2016 - 2018
                </p>
                <p className="cursus">
                  I pursued a Computer Programmer course at Seneca College, where I gained a solid foundation in software development and data analytics. The program equipped me with comprehensive knowledge in programming languages, system design, and database management, while also honing my skills in analyzing data to derive actionable insights. This combination of development expertise and analytics proficiency set the stage for my career, allowing me to effectively bridge the gap between technical development and data-driven decision-making.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
   
      {/* <!-- ====================================== Section Coding Skill End ===================================== --> */}
      {/* <!-- ====================================== Section Award ===================================== --> */}

      {/* <!-- ====================================== Analytics  Skills Section ===================================== --> */}

      <section className="design-skill-section mt-4" id="analyticsSkills">
        <div className="heading-container">
          <h2 className="section-heading-text design-skill-text">
            Data & Analytics.
          </h2>
          <div className="line"></div>
        </div>
        <div className="design-skill-sub-section d-flex">
          <div className="design-skills-img-main  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={adobeAnalytics} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main">
              <p>Adobe </p>
              <p>Analytics</p>
            </div>
          </div>
          <div className="design-skills-img-main photoshop  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={launch} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main photoshop-text">
              <p>Adobe</p>
              <p>Launch</p>
            </div>
          </div>
          <div className="design-skills-img-main adobe-xd  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={aep} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main adobe-xd-text">
              <p>AEP</p>
              <p></p>
            </div>
          </div>

          <div className="design-skills-img-main adobe-xd  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={target} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main adobe-xd-text">
              <p>Adobe</p>
              <p>Target</p>
            </div>
          </div>

          <div className="design-skills-img-main sketch  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={ot} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main sketch-text">
              <p>OneTrust</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main invision  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={qm} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main invision-text">
              <p>Quantum</p>
              <p>Metrics</p>
            </div>
          </div>
          <div className="design-skills-img-main invision-1  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 show">
            <div style={{ width: "50px", height: "50px" }}><img src={qualtrics} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main invision-text ">
              <p>Qualtrics</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main invision-2  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 show">
            <div style={{ width: "50px", height: "50px" }}><img src={dynatrace} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main invision-text">
              <p>dynatrace</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main invision-3  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 show">
            <div style={{ width: "50px", height: "50px" }}><img src={ga4} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main invision-text">
              <p>GA4</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main invision-4  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 show">
            <div style={{ width: "50px", height: "50px" }}><img src={gtm} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main invision-text">
              <p>GTM</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main invision-5  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 show">
            <div style={{ width: "50px", height: "50px" }}><img src={audience} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main invision-text">
              <p>Audience</p>
              <p>Manager</p>
              
            </div>
          </div>
          <div className="design-skills-img-main invision-6  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 show">
            <div style={{ width: "50px", height: "50px" }}><img src={databricks} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main invision-text">
              <p>DataBricks</p>
              <p></p>
              
            </div>
          </div>
        </div>
      </section>

      {/* <!-- ====================================== Front End Skills Section ===================================== --> */}
      <section className="design-skill-section mt-4" id="frontend">
        <div className="heading-container">
          <h2 className="section-heading-text design-skill-text fade_up">
            Front End Skills.
          </h2>
          <div className="line"></div>
        </div>
        <div className="design-skill-sub-section d-flex">
          <div className="design-skills-img-main  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={javasscript} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main">
              <p>Javascript </p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main   col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 photoshop">
            <div style={{ width: "50px", height: "50px" }}><img src={react} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main photoshop-text">
              <p>React</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main   col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 adobe-xd">
            <div style={{ width: "50px", height: "50px" }}><img src={angular} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main adobe-xd-text">
              <p>Angular</p>
              <p></p>
            </div>
          </div>

          <div className="design-skills-img-main   col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 sketch">
            <div style={{ width: "50px", height: "50px" }}><img src={htmll} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main sketch-text">
              <p>HTML</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main   col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 invision">
            <div style={{ width: "50px", height: "50px" }}><img src={csss} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main invision-text">
              <p>CSS</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 invision-3 show">
            <div style={{ width: "50px", height: "50px" }}><img src={typescriptt} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main invision-text ">
              <p>Typescript</p>
              <p></p>
            </div>
          </div>
        </div>
      </section>
      
      {/* <!-- ====================================== Backend & Databases Skills Section ===================================== --> */}
      <section className="design-skill-section mt-4" id="database">
        <div className="heading-container">
          <h2 className="section-heading-text design-skill-text fade_up">
            Backend & Database Skills.
          </h2>
          <div className="line"></div>
        </div>
        <div className="design-skill-sub-section d-flex">
          <div className="design-skills-img-main  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <div style={{ width: "50px", height: "50px" }}><img src={nodejs} style={{ width: "100%" }} alt="adobe-img" /></div>
            <div className="skill-counter-main">
              <p>NodeJS </p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 photoshop">
            <div style={{ width: "50px", height: "50px" }}><img src={python} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main photoshop-text">
              <p>Python</p>
              <p></p>
            </div>
          </div>
          <div className="design-skills-img-main  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 adobe-xd">
            <div style={{ width: "50px", height: "50px" }}><img src={MongoDB} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main adobe-xd-text">
              <p>MongoDB</p>
              <p></p>
            </div>
          </div>

          <div className="design-skills-img-main  col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5 sketch">
            <div style={{ width: "50px", height: "50px" }}><img src={postgresql} style={{ width: "100%" }} alt="adobe-img" /></div>

            <div className="skill-counter-main sketch-text">
              <p>PostgreSQL</p>
              <p></p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- ====================================== Section Award End ===================================== --> */}
    </>
  );
};
export default Resume;
